import type { ChartData } from 'chart.js'

export function changedIn2months(chartData: Record<string, ChartData>): boolean {
  return chartData[60].datasets[0].data.some((rate) => rate !== chartData[60].datasets[0].data[0])
}
